import { render } from "./AddLocationModal.vue?vue&type=template&id=da2c226c"
import script from "./AddLocationModal.vue?vue&type=script&lang=js"
export * from "./AddLocationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__